import './Loader.css';
import React, { useEffect, useState } from 'react';

const Loader = ({ text = "Loading" }) => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const warningTimeout = setTimeout(() => {
      setShowWarning(true);
    }, 10000);

    return () => {
      clearTimeout(warningTimeout);
    };
  }, []);

  return (
    <div className="loader-frame">
      <span className="loader-text">{text}</span>

      {showWarning && (
        <div
          style={{
            marginTop: "12px",
            color: "red",
            fontWeight: "bold",
          }}
        >
          ⚠️ Taking longer than usual. Please check your internet connection.
        </div>
      )}
    </div>
  );
};

export default Loader;
